(function Module() {
	'use strict';

	mySynch.controller('NewFarmController', [
		'$scope',
		'$rootScope',
		'MySynchFactory',
		'ApiFactory',
		'F360Constant',
		'broadCastService',
		'mySynchEnumerationService',
		'mySynchConstantService',
		'performanceMetricsService',
		'performanceContextService',
		'clientLoggerService',
		function NewFarmController($s,$rootScope, MSF, api,constant,broadCastSrv,mySynchEnumSvc,mySynchConstSvc,perfMetricSvc, perfContextSvc, log) {
			$s.performanceContext = null;
			var defaultPersonTypeId = 6; // "Other"
			$s.data = {
				territoryManager: {
					name: MSF.cookies.user.FirstName + ' ' + MSF.cookies.user.LastName,
					phone: MSF.cookies.user.Phone,
					email: MSF.cookies.user.Email,
					personId: MSF.cookies.user.PersonId
				},

				person: {
					EULAAcceptedOn: null,
					personTypeId: defaultPersonTypeId
				},

				farm: {
					status: _.get(mySynchEnumSvc.getMySynchEnumeration('FarmStatus','ACTIVE'),'value')
				},
				herd: {
					herdMgmtSoftware: ""					
				},
			

				all: {}
			};
			$s.MSF		= MSF;
			$s.loading	= false;
		
			$s.codeFile = [];
			
			$s.countries = [];
			$s.statesAndProvinces = [];
			$s.states = [];
			$s.farmTypes	= MSF.lists.farmType;
			$s.breedNames	= MSF.lists.breedName;
			$s.herdManagementSoftwareList = [];
			$s.measurementStandards = [];
			$s.defaultMeasurementStandardCode = 'IMPERIAL';
			$s.defaultMeasurementStandard = {};

			$s.loadSelectOptions = function loadSelectOptions(){
				perfMetricSvc.startTiming("Page:NewFarm:Build");

				$s.loadHerdManagementSoftwareList();	

				$s.loadCountryList();

				$s.loadStateList();

				$s.loadMeasurementStandardList();

				perfMetricSvc.endTiming("page","Page:NewFarm:Build", $s.performanceContext);
			} 

			$s.loadHerdManagementSoftwareList = function loadHerdManagementSoftwareList(){   
			   $s.herdManagementSoftwareList = _.filter($s.codeFile,{codeType: "HERDMGMTSW"});
			}

			$s.loadCountryList = function loadCountryList(){
				$s.countries = _.filter($s.codeFile,{codeType: "COUNTRY"});
			}

			// function that loads $s.satesAndProvinces with available countries and their states(or Provinces)
			// and then sets the state dropdown options to the states\provinces for the farm's country
			$s.loadStateList = function loadStateList(){
				var countries = _.filter($s.codeFile,{codeType: "COUNTRY"}); 
				
				var allStatesAndProvinces = MSF.getCodeFileSubsetWithParsedDetailsJson(_.filter($s.codeFile,function(codeFileItem){
					var codeType = _.get(codeFileItem,'codeType');
					return _.isEqual(codeType,'STATE') || _.isEqual(codeType,'PROVINCE');
				}));

				_.forEach(countries,function(country){
				   
                    var countryCode = _.get(country,'code');

					var stateList = {
						country : countryCode,
						states: _.filter(allStatesAndProvinces,function(stateAndProvinceItem){
							         return _.isEqual(_.get(stateAndProvinceItem,'detailsJson.country'),countryCode);
							    })
					}

					$s.statesAndProvinces.push(stateList);

				});


			}

			$s.loadMeasurementStandardList  = function loadMeasurementStandardList(){
				var measurementStandards = _.filter($s.codeFile,{codeType: "MEASUREMENTSTANDARD"}); 

				var parsedMeasurementStandards = MSF.getCodeFileSubsetWithParsedDetailsJson(measurementStandards);
				
				$s.measurementStandards = parsedMeasurementStandards;

				$s.defaultMeasurementStandard = _.find(parsedMeasurementStandards,{code: $s.defaultMeasurementStandardCode});
				
				// setting default measurement standard for new farms. 
				$s.setMeasurementStandard($s.defaultMeasurementStandard);

			}



			  // sets the options available in the states dropdown
			  $s.setStateList = function setStateList(country){
				 
				var states = _.get(_.find($s.statesAndProvinces,{country: country}),'states',[]) ;

				$s.states = states;
				 
			}

			$s.setMeasurementStandard = function setMeasurementStandard(measurementStandard){
				var measurementStandardCode  = _.get(measurementStandard,'code');
				
				_.set($s.data.farm,'measurementStandard',measurementStandardCode);
			}

			// on change of the country field, we want to reload the state\province options
			$s.onCountryChange = function onCountryChange(country){

                $s.setStateList(country);

			}

			$s.createFarmAndPerson = function createFarmAndPerson() {
				if (!$s.farmForm.$valid) {
					MSF.touchForm($s.farmForm);

					return false;
				}

				$s.loading = true;
				var previousNumFarms = MSF.getAvailableFarms().length;      
				api.createFarmAndPerson($s.data, function farmAndPersonCreated(err, newFarmAndPerson) {
					$s.loading = false;

					if (err) {
						return log.error(MSF.notify.danger('Error creating farm and person ' + err));
					}

					// newFarmAndPerson : {createFarm : { farmId : 1}}, createPerson : {EULAAcceptedOn : null, email : "" , firstName: "" , lastName: "", personId: 1, personKey: "", personTypeId: 1, phone: "" } 
                    log.info(MSF.notify.success('Farm and Farm Admin created successfully, email sent to Farm Admin'));
                    
					var newFarmId = _.get(newFarmAndPerson,'createFarm.farmId');
					api.getFarmWithHerdsByFarmId(newFarmId, function getFarmWithHerdsByFarmId(err, farmWithHerdsResult){
                           var farm = {}
						   var herds = [];
						   try {
							   farm = JSON.parse(_.get(farmWithHerdsResult,'farm',"{}"));
						   } catch (error) {
							  console.log("Failed to parse new tm farm : "+error);
						   }

						  try {
						    	herds = JSON.parse(_.get(farmWithHerdsResult,'herds',"[]"));
						  } catch (error) {
							console.log("Failed to parse new tm herds : "+error);
						  }

						  if(!_.isEmpty(farm) && !_.isEmpty(herds)){

                            farm = MSF.lowerCaseObjectKeys(farm);
							herds =  _.map(herds,MSF.lowerCaseObjectKeys);

							var availableFarms = MSF.getAvailableFarms();

							availableFarms.push(farm);

							var sortedAvailableFarms = MSF.getSortedListOfAvailableFarms(availableFarms);
							
							MSF.setAvailableFarms(sortedAvailableFarms);
							var previousHasOnlyNonDC305 = MSF.userHasOnlyNonDC305Farms();
							MSF.updateAvailableHerdListOptions().then((availableHerdListOptionsResults)=>{
								MSF.updateAdditionalHerdDData().then((additionalHerdDataResults)=>{
									$rootScope.$broadcast("farm:created", {});
									broadCastSrv.sendFarmCreatedMsg(farm);
									// need to check if a farm updated , removed or added needs to change the navigation
									if((!_.isEqual(previousNumFarms,MSF.getAvailableFarms().length)) || !_.isEqual(previousHasOnlyNonDC305,this.MSF.userHasOnlyNonDC305Farms())){
										broadCastSrv.updateNavigationMsg({updateSections:[{name:"MultiFarmSection",sectionType:"MultiFarm"},{name:"SingleFarmSection",sectionType:"SingleFarm"}]});
									}
									MSF.loadPageForFarmId("FarmAdmin",_.get(herds[0],'herdId'),_.get(farm,'farmId'),true,'user',false,true);
							    });
						    });
						}else{
						 //	MSF.loadPage('TerritoryDashboard');
							MSF.loadPage('FarmAdmin');
						}
					});

					

				});

			
			};

			$s.cancel = function cancel() {
				var optionalParams = {selectedTabName: mySynchConstSvc.defaultTerritoryManagerDashboardTab};
				MSF.loadPage('TerritoryDashboard',optionalParams);
			};

			MSF.ready(function whenMsfReady() {
				$s.performanceContext = perfContextSvc.createPerformanceContext();
				perfMetricSvc.startTiming("Page:NewFarm:Render");
				$s.codeFile =  _.cloneDeep(_.get(MSF,"lists.codeFile",[])); 
				$s.loadSelectOptions();

				perfMetricSvc.markPageReady("Page:NewFarm:Render", $s.performanceContext);
			});
		}
	]);
})();
